/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Header from "../core/header/Header";
import AppContent from "../core/appContent/AppContent";
import Sidebar from "../core/sidebar/Sidebar";
// import Footer from "../core/footer/Footer";
import { useLocation } from "react-router-dom";
import { privatePaths } from "router/paths";
import { useAppSelector } from "store/hooks";

export default function DefaultLayout() {
  const isMobileTablet = useAppSelector((state) => state?.deviceDetection?.isMobileTabletDevice);
  const location = useLocation();
  if (
    location.pathname === privatePaths.adminDashboard ||
    location.pathname === privatePaths.adminUserManagement ||
    location.pathname === privatePaths.transactionLogs
  ) {
    return (
      <div className="main-container">
        <Box sx={{ display: "flex" }}>
          <CssBaseline />
          {!isMobileTablet ? <Sidebar /> : null}
          <Box component="main" sx={{ flexGrow: 1, pt: 1, pb: 0, px: 2, overflow: "auto" }}>
            <Header />
            <AppContent />
            {/* <Footer /> */}
          </Box>
        </Box>
      </div>
    );
  } else {
    return <AppContent />;
  }
}
